// PercentageInputField.jsx
const PercentageInputField = ({
  label,
  name,
  value,
  setValue,
  error,
  setError,
  sign,
  placeholder = "Enter value",
}) => {
  const handleChange = (e) => {
    const val = e.target.value;
    const numeric = parseFloat(val);

    if (val === "" || /^[0-9]*\.?[0-9]*$/.test(val)) {
      setValue(val);
      setError("");
    }

    if (!isNaN(numeric) && numeric > 100) {
      setError("Value must not exceed 100");
    }
  };

  const handleBlur = (e) => {
    const numeric = parseFloat(e.target.value);
    setValue(numeric.toFixed(2));

    if (numeric > 100) {
      setError("Value must not exceed 100");
    } else {
      setError("");
    }
  };

  return (
    <div className="w-full">
      <label
        htmlFor={name}
        className="mb-1 mt-4 text-sm text-labelColour block"
      >
        {label}
      </label>
      <div className="relative w-full">
        <div className="relative">
          <input
            type="text"
            name={name}
            id={name}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={placeholder}
            className={`p-2 pr-8 text-black w-full font-medium border rounded-md text-md transition-all duration-200 ${
              error ? "border-red-500" : "border-gray-300"
            }`}
          />
          <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
            <span className="text-gray-500 text-sm">{sign}</span>
          </div>
        </div>

        <div
          className={`overflow-hidden transition-all duration-300 ${
            error ? "max-h-10 opacity-100 mt-1" : "max-h-0 opacity-0"
          }`}
        >
          <p className="text-red-600 text-xs flex items-center gap-1">
            <img src="/danger.svg" alt="error" className="w-4 h-4" />
            {error}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PercentageInputField;
